angular.module('impactx.search').controller('ProductListCtrl', [
    'SearchFilter',
    ProductListController
]);

function ProductListController(SearchFilter) {
    var self = this;
    self.nameSort = 0;
    self.priceSort = 0;

    self.sortByName = function () {
        self.priceSort = 0;
        self.nameSort = SearchFilter.sortByName(self.containerCtrl.notGlobal);
        search();
    };

    self.sortByPrice = function () {
        self.nameSort = 0;
        self.priceSort = SearchFilter.sortByPrice(self.containerCtrl.notGlobal);
        search();
    };

    function search() {
        var selectedSort = null;
        if (self.nameSort) {
            selectedSort = SearchFilter.getSelectedSort(self.nameSort)
        }
        else if (self.priceSort) {
            selectedSort = SearchFilter.getSelectedSort(self.priceSort)
        }

        self.containerCtrl.updateContent(1, selectedSort);
    }
}